import React from "react";
import { RMarker } from "maplibre-react-components";
import { useLocationStore } from "@/store/userPosition";
import cls from "./styles.module.scss";

export default function UserLocationMarker() {
  const location = useLocationStore((s) => s.location);

  return location ? (
    <RMarker
      key="user"
      longitude={location.longitude}
      latitude={location.latitude}
    >
      <div className={cls.locationCircle}>
        <div className={cls.locationDot} />
      </div>
    </RMarker>
  ) : null;
}
